<h2 mat-dialog-title>Czy na pewno chcesz usunąć ten kontrakt cenowy?</h2>
<div mat-dialog-actions fxLayout="row">
    <button-spinner class="ml-xm" [inProgress]="deleting">
        <button mat-button [disabled]="deleting" (click)="onNoClick()">Zamknij</button>
        <button mat-button [disabled]="deleting" (click)="deletePriceContractClick()">Usuń kontrakt</button>
    </button-spinner>
</div>
